export const faqs = () => [
  {
    label: 'Ik heb problemen met de Dumpert App. Wat moet ik doen?',
    content: `Zorg dat je nieuwste versie hebt gedownload uit de App Store. Heb je nog steeds klachten? Mail dan naar <a href="mailto:feedback@dumpert.nl" target="_blank" rel="noopener noreferrer">feedback@dumpert.nl</a> en vergeet daarbij niet:
    <br/><br/>
    <ul style="list-style: disc; padding-left: 20px;">
    <li>Je versienummer van de app te vermelden. Deze staat onderaan het Dumpertmenu in de app</li>
    <li>De omschrijving van je klacht</li>
    <li>Eventueel een screenshot mee te sturen</li>
    </ul>`,
  },
  {
    label: 'Hoe stuur ik een filmpje in?',
    content:
      'Dat kan gewoon op Dumpert zelf via het uploadformulier op de website, onze app via \'Dumpen\'  of stuur hem in via WhatsApp op <a href="tel:+31622443318" target="_blank" rel="noopener noreferrer">06-22443318</a>.',
  },
  {
    label: 'Waarom komt mijn filmpje of foto niet op Dumpert?',
    content:
      'Waarschijnlijk is het een repost en/of voldoet het niet aan onze andere <a href="/huisregels" target="_blank" rel="noopener noreferrer">huisregels</a>.',
  },
  {
    label: 'Waarom kan ik niet inloggen?',
    content: `Voeg eerst noreply@reaguurder.nl toe aan de contacten van je mailprogramma om uit te sluiten dat onze email in je spamfolder terecht komt. Daarna kun je je wachtwoord resetten via <a href="/wachtwoord/vergeten" target="_blank" rel="noopener noreferrer">wachtwoord vergeten</a>. Kom je er nog niet uit? Dan ben je waarschijnlijk een digibeet van 65+.
    <br/><br/>
    <ul style="list-style: disc; padding-left: 20px;">
    <li>Controleer nogmaals je spamfolder</li>
    <li>Controleer of je mailadres en wachtwoord kloppen.</li>
    <li>Kijk ook even of je niet toevallig inlogt met je gebruikersnaam in plaats van je emailadres.</li>
    <li>Zorg dat er geen spaties in of achter het wachtwoord en mailadres staan.</li>
    <li>Kijk of je CapsLock niet aanstaat bij het intypen van je wachtwoord.</li>
    </ul>
    `,
  },
  {
    label: 'Ik heb een ban gekregen, kan ik daar iets tegen doen?',
    content:
      'Check eerst eens de <a href="/huisregels" target="_blank" rel="noopener noreferrer">huisregels</a>. Ben je het nog steeds niet eens? Ga naar <a href="/contact" target="_blank" rel="noopener noreferrer">contact</a> en kies \'Ik ben het niet eens met mijn ban\'. Geef je nickname en mailadres aan en de reden dat je het er niet mee eens bent.',
  },
  {
    label: 'Waarom lukt het registeren niet?',
    content:
      'Zorg dat je een werkend legitiem emailadres gebruikt. Gebruik dus geen weggooi-emailadres. Na het registeren sturen we je een email die je moet bevestigen. Het kan zijn dat de deze email in je spamfolder terecht komt. Om dit uit te sluiten voeg je noreply@reaguurder.nl toe aan de contacten van je mailprogramma. Als je probeert te registreren, hoef je alleen maar gebruikersnaam op te geven, zonder spaties (deze zijn niet toegestaan), emailadres opgeven, wachtwoord opgeven, captcha (Ik ben geen robot) invullen en versturen.',
  },
  {
    label: 'Er wordt aangegeven dat mijn emailadres niet bestaat. Wat kan ik doen?',
    content:
      'Als je probeert in te loggen betekent de melding dat het mailadres niet in ons systeem staat. Controleer of je niet je gebruikersnaam in het email veld invult. Als je probeert te registreren, hoef je alleen maar je gebruikersnaam op te geven zonder spaties (deze zijn niet toegestaan), emailadres opgeven, wachtwoord opgeven, captcha (Ik ben geen robot) aanvinken en versturen.',
  },
  {
    label: 'Helpie. Ik ben mijn wachtwoord vergeten. Wat nu?',
    content:
      'Je kunt je wachtwoord resetten via <a href="/wachtwoord/vergeten" target="_blank" rel="noopener noreferrer">wachtwoord vergeten</a>. Vul je emailadres in en klik op \'Stuur herstel link\'. Je ontvangt een mail met verdere instructies. Geen mail gekregen? Check je spamfolder als je de bevestigingsmail niet kunt vinden!',
  },
  {
    label: 'Hoe kan ik mijn gebruikersnaam wijzigen?',
    content:
      'Je kan je gebruikersnaam 1 keer per jaar aanpassen via <a href="/reaguurder/instellingen" target="_blank" rel="noopener noreferrer">reaguurder instellingen</a>. Klik op de knop wijzigen bij het kopje reaguurdernaam.',
  },
  {
    label: 'Help! Mijn reclamevrij abonnement werkt niet (meer).',
    content:
      "Denk je eindelijk van die kutreclames verlost te zijn, werkt het niet. Als het goed is heb je Reclamevrij gekocht via je Dumpert App. Ga in de app naar 'Verwijder advertenties' en kijk of je abonnement nog actief is en er resterende dagen zijn. Als je er zeker van bent dat deze nog gewoon moet werken kies dan 'Herstel eerdere aankopen'. Alles zou nu weer goed moeten werken. Dit abonnement zit helaas niet gekoppeld aan je Reaguurderaccount, het zit aan je App Store / Google play vast en kun je dus niet meenemen als je naar een ander OS gaat. Ook werkt het (nog) niet op de website. We zijn dit nog aan het bouwen en daarom is het nu nog zo verdomd goedkoop. Als dit eenmaal vloeiend werkt gaan we de prijs verhogen naar 89,- euro per maand. Nee grapje, we blijven lekker cheap (net als je moeder).",
  },
  {
    label:
      'Ik heb reclamevrij aangeschaft op de APP maar ik zie nog steeds reclame op de WEBSITE. Hoe kan dat?',
    content:
      'Dumpert Reclameloos werkt momenteel alleen nog op de app. We zijn bezig om het te koppelen met de website zodat je overal kunt genieten van een reclameloze omgeving. Als dat kan, laten we het zeker weten!',
  },
  {
    label:
      'Ik heb reclamevrij aangeschaft op Android maar verhuis nu naar Apple. Of andersom. Kan ik reclamevrij meenemen?',
    content:
      'Nee nog niet. We zijn bezig om het te koppelen zodat je overal en op elk device kunt genieten van een reclameloze omgeving. Als dat kan, laten we het zeker weten!',
  },
  {
    label:
      'Ik heb reclamevrij aangeschaft op de app, maar ik zie daar nog steeds reclames. Hoe kan dat?',
    content:
      ' We \'embedden\' af en toe Twitter, Facebook of de YouTube player. Het kan zijn dat je daardoor heel af en toe toch reclame krijgt. Deze kunnen wij helaas niet voor je uitzetten. Krijg je reclames bij Dumpertfilmpjes ondanks dat je abonnement nog actief is? Neem dan contact op met <a href="mailto:feedback@dumpert.nl" target="_blank" rel="noopener noreferrer">feedback@dumpert.nl</a>. Stuur een screenshot mee van je actieve abonnement (staat in het menu onder \'Reclames verwijderen\', de app versie (staat onderin het menu) en vermeld duidelijk je klacht.',
  },
  {
    label: 'Hoe kan ik al mijn gegevens bij jullie verwijderen?',
    content:
      'Ga naar <a href="/reaguurder/instellingen" target="_blank" rel="noopener noreferrer">reaguurder instellingen</a> en klik op de knop bevestigen bij het kopje account verwijderen. Nadat dit doorlopen is zal jouw account zijn verwijderd van Dumpert. Jouw reacties zullen worden geanonimiseerd waardoor deze niet meer te koppelen zijn aan jouw gegevens en alle IP adressen worden verwijderd uit ons systeem. Vaarwel!',
  },
  {
    label: 'Hoe verwijder ik een filmpje van Dumpert?',
    content: `Stuur een mailtje naar <a href="mailto:gezeur@dumpert.nl" target="_blank" rel="noopener noreferrer">gezeur@dumpert.nl</a>. Vergeet daarbij niet de volgende gegevens mee te sturen, anders nemen we je klacht simpelweg niet in behandeling:
    <br/><br/>
    <ul style="list-style: disc; padding-left: 20px;">
    <li>Je naam, e-mailadres en telefoonnummer</li>
    <li>Om welke content het gaat, inclusief de exacte URL van de pagina waarop de betreffende content gepubliceerd is</li>
    <li>De reden dat deze content verwijderd zou moeten worden</li>
    <li>Jouw relatie tot deze content (voor zover van toepassing)</li>
    </ul>`,
  },
];

export const faqsDeluxe = [
  {
    label: 'Ik wil een filmpje van Dumpert af hebben',
    content: 'Daarvoor moet je mailen naar gezeur@dumpert.nl',
  },
  {
    label:
      'Ik kan geen filmpjes meer van jullie bekijken op de app. Zouden jullie dit misschien willen oplossen?',
    content: 'Probeer je energiebesparing uit te zetten op je device.',
  },
  {
    label: 'Ik wil een filmpje op Dumpert uploaden',
    content:
      "Dat kan gewoon op Dumpert zelf via het Uploadformulier of op <a href='https://bit.do/dumpertupl' rel='noreferrer' target='_blank'>https://bit.do/dumpertupl</a> of via WhatsApp op 0622443318.",
  },
  {
    label: 'Ik kan niet inloggen?',
    content: `Controleer eerst dat je mailadres en wachtwoord kloppen.
      Kijk ook even of je niet toevallig inlogt met je gebruikersnaam in plaats van mailadres.
      Zorg dat er geen spaties in of achter het wachtwoord en mailadres staan.
      Kijk of je CapsLock niet aanstaat... Kom je er nog niet uit?
      Ga naar <a href='https://www.dumpert.nl/contact' rel='noreferrer' target='_blank'>https://www.dumpert.nl/contact</a>, stel je vraag daar en dan kijken we er meteen naar.`,
  },
  {
    label:
      'Ik kan niet meer inloggen op de website. Wel op reaguuder.nl. Dit geldt alleen voor de browser (Safari). De IoS app werkt prima.',
    content:
      "Stuur dit even door via <a href='https://www.dumpert.nl/contact' rel='noreferrer' target='_blank'>https://www.dumpert.nl/contact</a> en onze developers gaan er meteen mee aan de slag.",
  },
  {
    label: 'Ik heb een ban!',
    content:
      "Check eerst eens de huisregels op <a href='https://www.dumpert.nl/huisregels/' rel='noreferrer' target='_blank'>https://www.dumpert.nl/huisregels/</a>. Ben je het nog steeds niet eens? Ga naar <a href='https://www.dumpert.nl/contact' rel='noreferrer' target='_blank'>https://www.dumpert.nl/contact</a> en kies 'Ik ben het niet eens met mijn ban'. Geef je nickname en mailadres aan en de reden dat je het er niet mee eens bent.",
  },
  {
    label: 'Hoe kan ik mijn reaguursel wijzigen',
    content:
      'Klik binnen 5 minuten op het menu-item (3 puntjes boven elkaar), selecteer “Reaguursel aanpassen. Pas het reaguursel aan en klik op “Verzenden”. Je reaguursel zal nu aangepast zijn en niet nogmaals aanpasbaar. Na 5 minuten is het reaguursel niet meer aan te passen',
  },
  {
    label: 'Het registreren lukt niet',
    content:
      'Als je probeert te registreren, hoef je alleen maar gebruikersnaam op te geven, zonder spaties (deze zijn niet toegestaan), emailadres opgeven, wachtwoord opgeven, captcha (Ik ben geen robot) aanvinken en versturen',
  },
  {
    label: 'Er wordt aangegeven dat mijn emailadres niet bestaat',
    content: `Voor inloggen: De melding betekent dat het mail-adres niet in ons systeem staat. Controleer dat je niet je gebruikersnaam in het email veld invult.
    Als je probeert te registreren, hoef je alleen maar, gebruikersnaam op te geven zonder spaties (deze zijn niet toegestaan), emailadres opgeven, wachtwoord opgeven, captcha (Ik ben geen robot) aanvinken en versturen.`,
  },
  {
    label: 'Hoe kan ik het mailadres bij mijn gebruikersnaam achterhalen?',
    content:
      "Ga naar <a href='https://www.dumpert.nl/contact' rel='noreferrer' target='_blank'>https://www.dumpert.nl/contact</a> en klik op Reageer. Kopieer de vraag 'Ik weet het mailadres niet meer bij de gebruikersnaam ... en dan je gebruikersnaam. Kunnen jullie die voor mij achterhalen?'. Klik op verstuur en de redactie gaat dan kijken of ze hem voor je kunnen achterhalen.",
  },
  {
    label: 'Ik ben mijn wachtwoord vergeten',
    content:
      "Ga naar <a href='https://www.reaguurder.nl/contact' rel='noreferrer' target='_blank'>https://www.reaguurder.nl/contact</a> en klik op wachtwoord veranderen / herstellen. Klik op de button 'Klik hier om je wachtwoord te veranderen'. Log in en vul je oude en nieuwe wachtwoord in en klik op 'verander wachtwoord'.\"",
  },
  {
    label: 'Hoe kan ik mijn gebruikersnaam wijzigen?',
    content:
      "Enige manier om je gebruikersnaam te wijzigen is door via <a href='https://reaguurder.nl/contact' rel='noreferrer' target='_blank'>https://reaguurder.nl/contact</a> de optie 'Username veranderen' te kiezen. Hou er wel rekening mee, dat hierdoor al jouw eerdere reacties anoniem worden en dat je weer als Zwitsal start. In feite verwijder je daarmee dit account en maak je een nieuwe aan.",
  },
  {
    label: 'Hoe kan ik al mijn gegevens bij jullie verwijderen?',
    content:
      "Om je Dumpert DeLuxe account te verwijderen: ga naar <a href='https://www.dumpert.nl/deluxe/profiel' rel='noreferrer' target='_blank'>https://www.dumpert.nl/deluxe/profiel</a> en log in. Klik op 'Zet Dumpert DeLuxe uit'. Het lidmaatschap zal nu stopgezet zijn. Verwijder voor de volledigheid ook de betaalmethode. In principe kan je nog gebruikmaken van Dumpert DeLuxe tot het eind van de periode. Om je account volledig te verwijderen, ga naar <a href='' rel='noreferrer' target='_blank'></a>https://dumpert.nl/user/delete en doorloop het proces om jouw account te verwijderen. Nadat dit doorlopen is zal jouw account zijn verwijderd van Dumpert. Jouw reacties zullen worden geanonimiseerd waardoor deze niet meer te koppelen zijn aan jouw gegevens en alle IP adressen worden verwijderd uit ons systeem.",
  },
  {
    label: 'Hoe kan ik mijn Dumpert DeLuxe stopzetten?',
    content:
      "Ga eerst naar <a href='https://www.dumpert.nl/deluxe/profiel' rel='noreferrer' target='_blank'>https://www.dumpert.nl/deluxe/profiel</a> en log in. Klik op 'Zet Dumpert DeLuxe uit'. Verwijder ook de betaalmethode. Mocht dit niet correct verlopen, neem dan contact op met onze service desk via het contactformulier",
  },
  {
    label:
      'Is er sprake van stilzwijgende verlenging of geven jullie aan wanneer een nieuwe periode ingaat',
    content:
      'Er is sprake van stilzwijgende verlenging. Maandelijks worden de abonnementskosten van je rekening geïncasseerd. Hieraan kun je zien dat je weer een maand gebruik kunt maken van Dumpert DeLuxe.',
  },
  {
    label: 'Per wanneer kan ik mijn abonnement op Dumpert DeLuxe opzeggen?',
    content: `Als je je abonnement wil opzeggen kan je dat op elk moment doen en zal het abonnement blijven doorlopen tot het einde van de aangekochte periode. Je houdt dus toegang tot alle Dumpert features tot het einde van je factureringsperiode.
    <br><br>
    Als je hebt gekozen voor een abonnement tegen actietarief dan is het abonnement maandelijks opzegbaar na het einde van de actieperiode.`,
  },
  {
    label:
      'Er is een bedrag afgeschreven uit naam van Mediahuis Nederland B.V. maar ik weet nergens van',
    content:
      'Dumpert is onderdeel van Mediahuis, vandaar dat er wordt geïncasseerd. Mocht je hier nog verder vragen over hebben, neem dan contact op met onze Klantenservice via het contactformulier',
  },
  {
    label: 'Ik wil mijn Dumpert DeLuxe membership stopzetten',
    content:
      'Alleen is deze juist niet meer relevant volgens mij, omdat we hebben besloten dat dit niet via de klantenservice gaat. Die redenen moeten aangevuld worden in “Hoe kan ik mijn Dumpert DeLuxe stopzetten?”',
  },
  {
    label: 'Waar kan ik een suggesties doen voor nieuwe features?',
    content:
      'Geef je nieuwe mogelijke features door via ons contact formulier en dan geven wij dat direct door aan onze developers.',
  },
  {
    label: 'Ik ben Deluxe member geworden, maar heb geen bevestiging hiervan ontvangen',
    content: 'Neem contact op met onze Klantenservice via het contactformulier',
  },
  {
    label: 'Waar kan ik mijn factuur vinden',
    content:
      'Je factuur kan je vinden door in te loggen en naar je profielpagina te gaan. Hier kan je bij jouw gegevens een link vinden naar je facturen',
  },
  {
    label: 'Waar is mijn bevestiging van opzegging',
    content:
      'Die zou per mail verstuurd moeten zijn. In het geval dit niet correct is, graag contact opnemen met de Klantenservice via het contactformulier',
  },
  {
    label: 'Hoe kan ik Deluxe member worden?',
    content:
      "Klik op de banner, abonneer of volg de link <a href='https://www.dumpert.nl/deluxe' rel='noreferrer' target='_blank'>https://www.dumpert.nl/deluxe</a>. Volg de stappen. Kies jouw abonnement, registreer en doe de betaling. Vanaf nu ben jij ook part of the gang.",
  },
  {
    label: 'Ik ben Deluxe member, maar mijn features werken niet',
    content:
      'Check of je ingelogd bent. De features zijn alleen dan beschikbaar. Doen de features het dan nog steeds niet, neem contact op met de Klantenservice via het contactformulier. Die controleren of het een issue is met de betaling of een technisch issue. Beide worden zo snel mogelijk verholpen',
  },
  {
    label: 'Hoe kan ik mijn automatische verlenging stoppen',
    content:
      'Dit kan door in te loggen en je abonnement op te zeggen op je profiel pagina. Mocht dit niet werken, neem contact op met Klantenservice via het contactformulier',
  },
  {
    label: 'Ik ben DeLuxe member, maar ben toch geband?',
    content:
      'Dumpert DeLuxe geeft je geen vrijbrief om de huisregels met betrekking tot reaguren te overtreden. De huisregels gelden ook voor Dumpert DeLuxe leden. Je houdt beschikking over al je features, maar kan alleen niet meer reaguren tot je ban is opgeheven',
  },
  {
    label: 'Ik wil mijn abonnement herroepen',
    content:
      'Er geldt een ontbindingsrecht periode van 14 dagen. De ontbindingsrecht periode gaat in op de dag dat je toegang tot Dumpert DeLuxe hebt ontvangen. Je kunt gebruik maken van je herroepingsrecht door contact op te nemen met de Klantenservice via het contactformulier.',
  },
  {
    label: 'Ik heb een vraag over de betaling',
    content: 'Neem hiervoor contact op met onze Klantenservice via het contactformulier',
  },
  {
    label: 'Ik wil mijn betaalwijze aanpassen',
    content: 'Neem hiervoor contact op met onze Klantenservice via het contactformulier',
  },
  {
    label: 'Ik wil de betaalfrequentie aanpasse',
    content:
      'Dit is helaas niet mogelijk. Wij incasseren maandelijks het membership tarief van je rekening.',
  },
  {
    label: 'Ik wil mijn betaalgegevens wijzigen',
    content: 'Neem hiervoor contact op met onze Klantenservice via het contactformulier',
  },
  {
    label: 'Ik heb problemen met mijn herhaalde betaling',
    content: 'Neem hiervoor contact op met onze Klantenservice via het contactformulier',
  },
  {
    label: 'Wat kost een Dumpert DeLuxe membership',
    content:
      'Je kunt kiezen tussen een maandelijks opzegbaar membership à € 3,99 per maand of je kunt eenmalig kiezen voor een actietarief van € 1,99 per maand met de looptijd van een jaar. Hou er rekening mee dat het membership tegen actietarief het eerste jaar niet kan worden opgezegd.',
  },
];
